export const generateDraftStudyFromToolArgs = (args: Record<string, any>): string => {
  const draftStudy = args.draft_study;

  if (!draftStudy || typeof draftStudy !== 'object') {
    return JSON.stringify(args, null, 2);
  }

  const items: string[] = [];

  if (draftStudy.title) {
    items.push(`# ${draftStudy.title}`);
  }

  const fields = Object.keys(draftStudy).filter((key) => key !== 'title' && key !== 'interview_guide');

  fields.forEach((key) => {
    const value = draftStudy[key];
    const formattedKey = key.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

    if (Array.isArray(value)) {
      if (key === 'questions') {
        const labels = value.map((q) => `- ${typeof q === 'object' && q.label ? q.label : q}`).join('\n');
        items.push(`**${formattedKey}:**\n${labels}`);
      } else {
        items.push(`**${formattedKey}:** ${value.join(', ')}`);
      }
    } else if (typeof value === 'object') {
      let readableValue = '';

      if (key === 'incentive' && value.amount_in_cents && value.currency) {
        const amount = (value.amount_in_cents / 100).toFixed(2);
        const method = value.method ? ` (${value.method})` : '';
        readableValue = `$${amount} ${value.currency}${method}`;
      } else if (key === 'segment' && value.title) {
        const source = value.source ? ` (${value.source})` : '';
        readableValue = `${value.title}${source}`;
      } else if (key === 'moderated_config' && value.scheduling_style) {
        readableValue = value.scheduling_style.replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase());
      } else {
        readableValue = JSON.stringify(value);
      }

      items.push(`**${formattedKey}:** ${readableValue}`);
    } else {
      items.push(`**${formattedKey}:** ${value}`);
    }
  });

  return items.join('\n\n');
};
